export type QueryParamValue = string | number | boolean | null | undefined;
export type QueryParams = Record<string, QueryParamValue>;

const CAMELIZE_SEGMENT = /[-_][a-z]/g;

export const toCamelCase = (value: unknown): unknown => {
  if (Array.isArray(value)) {
    return value.map((item) => toCamelCase(item));
  }

  if (value === null || typeof value !== 'object') {
    return value;
  }

  const source = value as Record<string, unknown>;
  const output: Record<string, unknown> = {};
  Object.keys(source).forEach((key) => {
    const camelKey = key.replace(CAMELIZE_SEGMENT, (segment) =>
      segment.toUpperCase().replace('-', '').replace('_', '')
    );
    output[camelKey] = toCamelCase(source[key]);
  });
  return output;
};

export const buildQueryString = (params: QueryParams): string => {
  const query = new URLSearchParams();
  Object.entries(params || {}).forEach(([key, rawValue]) => {
    if (rawValue == null) return;
    const value = String(rawValue);
    if (value === '') return;
    query.set(key, value);
  });
  return query.toString();
};

export const isUnauthorizedError = (error: unknown): boolean =>
  typeof error === 'object' && error !== null && (error as { status?: unknown }).status === 401;
